import { Navigate, Route } from 'react-router-dom';
import { Routes } from '@datadog/browser-rum-react/react-router-v6';
import { useCompanyInfo } from '../../utils/hooks/useCompanyInfo';
import { ConstraintView } from './ConstraintView';
import { OptimizationHome } from './OptimizationHome';
import { RunView } from './RunView';

export const LinearOptimizations = () => {
  const { cid: company } = useCompanyInfo();

  return (
    <Routes>
      <Route index element={<OptimizationHome company={company} />} />
      <Route path='constraints/:constraintId' element={<ConstraintView company={company} />} />
      <Route path='runs/:kpiWithRunId' element={<RunView company={company} />} />
      <Route path='*' element={<Navigate to='.' replace />} />
    </Routes>
  );
};
